import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ElementTypes, GaContext } from '@fcom/common/interfaces/gtm.interface';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';

@Component({
  selector: 'fcom-sidebar-item',
  styleUrls: ['./sidebar-item.component.scss'],
  templateUrl: './sidebar-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidebarItemComponent {
  private themeService = inject(FinnairThemeService);

  readonly ElementTypes = ElementTypes;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TRACKING_CONTEXT = GaContext.SECTION_NAVIGATION;

  title = input<string>();
  link = input<string>('');
  external = input<boolean>(false);
  openInNewTab = input<boolean>(false);
  active = input<boolean>(false);
  loginRequired = input<boolean>(false);
  styleClasses = input<string>('nordic-blue-900-text text-icon-primary');
  tracking = input<boolean>(false);
  trackingLabel = input<string | undefined>(undefined);
  hoveredBG = input<boolean>(false);

  isNewBrand = computed(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);
  trackingObj = computed(() => {
    if (!this.tracking()) {
      return null;
    }

    return {
      tracker: `${this.trackingLabel()}${this.link()}`,
      context: this.TRACKING_CONTEXT,
      type: this.ElementTypes.LINK,
    };
  });

  linkClicked = output<Event>();

  onLinkClick(clickEvent: Event): void {
    clickEvent.stopPropagation();
    this.linkClicked.emit(clickEvent);
  }
}
